import React, { useContext, useState } from "react";
import {
  Item,
  Button,
  Label,
  Segment,
  Table,
  Menu,
  Icon,
  Dropdown,
  Confirm,
  Container,
  Tab,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import ProjectStore from "../../../app/stores/projectStore";
import { Link } from "react-router-dom";

const ProjectList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [projectId, setProjectId] = useState("");
  const projectStore = useContext(ProjectStore);
  const {
    projectsByDate: projectsByDate,
    deleteProject: deleteProject,
    submitting,
    target,
  } = projectStore;

  const status = [
    "Started" ,
    "In-Progress" ,
    "Completed" ,
    "Claim Submitted",
    "Payment Received",
    "Closed" ,
    "Onhold" ,
    "Cancel" 
  ];
  
  const panes = status.map(stat => {
    return { menuItem: stat, render: () => 
    <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Project Code</Table.HeaderCell>
        <Table.HeaderCell>Job Type</Table.HeaderCell>
        <Table.HeaderCell>Order Number</Table.HeaderCell>
        <Table.HeaderCell width={1}>Status</Table.HeaderCell>
        <Table.HeaderCell>Address</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {projectsByDate.map((project) => (
       (project.status === stat) && <Table.Row key={project.id}>
          <Table.Cell>
            <Label>{project.projectCode}</Label>
          </Table.Cell>
          <Table.Cell>{project.jobType}</Table.Cell>
          <Table.Cell> {project.orderNumber}</Table.Cell>
          <Table.Cell>{project.status}</Table.Cell>
          <Table.Cell>{project.address}</Table.Cell>
          <Table.Cell>
            <Button.Group size="mini">
              <Button
                as={Link}
                to={`/projectmanagement/project/${project.id}`}
                size="mini"
                icon="zoom in"
                color="blue"
                title="View"
              />
              <Button
                name={project.id}
                size="mini"
                loading={target === project.id && submitting}
                //onClick={(e) => deleteProject(e, project.id)}
                onClick={() => {
                  setOpen(true);
                  setProjectId(project.id);
                }}
                icon="delete"
                color="red"
                title="Delete"
              />
              <Confirm
                open={open}
                onCancel={() => setOpen(false)}
                onConfirm={(e) => {
                  deleteProject(projectId);
                    setOpen(false);
                }}
                content="Are you sure you want to delete ?"
                confirmButton="Yes"
                size="mini"
                style={{
                  position: "relative",
                  maxHeight: "150px",
                  height: "auto",
                }}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>


  </Table> }})
     
     

  return (
    <Container>
      <Tab
      panes={panes}
      menu={{ pointing: true }}
    />
    </Container>
  );
};

export default observer(ProjectList);
